import { useQuery } from "@apollo/react-hooks";
import { ApolloError, QueryResult } from "@apollo/client";
import gql from "graphql-tag";
import { useAuth } from "src/hooks/useAuth";
import { useIsLoggedIn } from "src/hooks/useIsLoggedIn";

export enum VoucherStatus {
  Active = "active",
  Used = "used",
  Expired = "expired",
  Pending = "pending",
  Disabled = "disabled",
}

export type VoucherCurrency = {
  code: string;
  symbol: string;
  position: string;
};

export type Voucher = {
  id: string;
  code: string;
  cashDiscount: number;
  status: VoucherStatus;
  expiryDate?: string | null;
  currency?: VoucherCurrency;
  type?: string | null;
};

export type VouchersData = {
  vouchers: (Voucher | null)[] | null;
};

export const GET_VOUCHERS = gql`
  query vouchers {
    vouchers {
      id
      code
      cashDiscount
      status
      expiryDate
      type
      currency {
        code
        symbol
        position
      }
    }
  }
`;

type VouchersHook = {
  data: VouchersData | undefined;
  loading: boolean;
  error?: ApolloError;
  refetch: QueryResult<VouchersData>["refetch"];
};

const useVouchers = (skip = false): VouchersHook => {
  const { session, accessToken } = useAuth();
  const isLoggedIn = useIsLoggedIn();

  const { loading, error, data, refetch } = useQuery<VouchersData>(
    GET_VOUCHERS,
    {
      skip: !isLoggedIn || !session || skip,
      context: { token: accessToken },
    }
  );

  return { loading, error, data, refetch };
};

export { useVouchers };
